import { z } from 'zod';

import { IDENTIFIER_TYPE } from 'src/features/membership/types';

export type VisitorFormSchemaValues = z.infer<typeof visitorFormSchema>;
export const visitorFormSchema = z.object({
    entry_time: z.string(),
    identifier_type: z.enum(IDENTIFIER_TYPE),
    identifier_value: z.string(),
    zone: z.string(),
    gateway: z.string(),
    open_gateway: z.boolean().optional(),
});
